import React from "react";
import { Scale3d, Banknote, Truck, Route, Webhook, Workflow, HeartPulse, Bot } from "lucide-react";
import SequenceCard from "./SequenceCard";

export function Phase4Cards({ merchant, onWin }) {
  return (
    <>
      <SequenceCard id="T4200cr" kicker="ACCOUNTING" title="Processor Reconciliation & Auditing" Icon={Scale3d}
        runLabel="Reconcile" header={`Buy-rate vs. clearing report · ${merchant.name}`} outcome="Reconciled · $186 recovered"
        onDone={() => onWin("recon-186")}
        steps={[
          { label: "Clearing report imported", detail: "1,284 transactions · Oct" },
          { label: "Interchange matched", detail: "1,283 lines matched" },
          { label: "Discrepancy found", detail: "$186 over-billed assessment", warn: true },
          { label: "Auto-corrected", detail: "Adjustment filed with processor" },
        ]} />
      <SequenceCard id="T4300cr" kicker="ACCOUNTING" title="Automated Payouts & Commission Reports" Icon={Banknote}
        runLabel="Stage payouts" outcome="ACH batch released · 14 payees"
        steps={[
          { label: "ACH batch staged", detail: "14 payees · $41,860" },
          { label: "Agent statements generated", detail: "14 PDFs · emailed" },
          { label: "Owner approval", detail: "Approved in one tap" },
          { label: "Batch released", detail: "Settles Friday" },
        ]} />
      <SequenceCard id="T5100cr" kicker="LOGISTICS" title="Terminal Management & Deployment" Icon={Truck}
        runLabel="Deploy terminal" header={`Clover Flex · ${merchant.name}`} outcome="Terminal activated · live"
        steps={[
          { label: "Picked from inventory", detail: "SN C043UQ7731 · 38 left" },
          { label: "Ordered & shipped", detail: "UPS 1Z…884 · 2-day" },
          { label: "Delivered", detail: "Signed by J. Reyes" },
          { label: "Activated & boarded", detail: "MID linked · test sale passed" },
        ]} />
      <SequenceCard id="T5200cr" kicker="ROUTING" title="Gateway & MID-Routing Integration" Icon={Route}
        runLabel="Route traffic" outcome="Traffic rebalanced · 0 declines"
        steps={[
          { label: "MID A · 42% of traffic", detail: "Healthy" },
          { label: "MID B · 38% of traffic", detail: "Healthy" },
          { label: "MID C nearing cap", detail: "94% of monthly limit", warn: true },
          { label: "Load rebalanced", detail: "C → A/B automatically" },
        ]} />
    </>
  );
}

export function Phase5Cards({ merchant, onWin }) {
  return (
    <>
      <SequenceCard id="T5300cr" kicker="DEVELOPER" title="Developer API & Webhooks" Icon={Webhook}
        runLabel="Fire webhook" outcome="Webhook delivered · 200 OK"
        steps={[
          { label: "API key generated", detail: "vrg_live_••••9f2c" },
          { label: "Event subscribed", detail: "merchant.approved" },
          { label: "Test webhook fired", detail: "POST /hooks/veroogle" },
          { label: "Payload received", detail: `{ "merchant": "${merchant.name}" }` },
        ]} />
      <SequenceCard id="T4480cr" kicker="AUTOMATION" title="Workflow Logic" Icon={Workflow}
        runLabel="Build rule" outcome="Rule live · triggered once"
        steps={[
          { label: "WHEN volume drops 30% week over week", detail: "Trigger" },
          { label: "THEN text the assigned agent", detail: "Action 1" },
          { label: "AND open a retention task", detail: "Action 2" },
          { label: "Rule triggered", detail: `${merchant.name} · -32%` },
        ]} />
      <SequenceCard id="T6100cr" kicker="MERCHANT SUCCESS" title="Merchant Success & Churn Warning" Icon={HeartPulse}
        runLabel="Scan portfolio" outcome="Merchant retained · offer accepted"
        onDone={() => onWin("retained")}
        steps={[
          { label: "Volume trend analysed", detail: "Brew & Bean · -28% in 3 weeks", warn: true },
          { label: "Churn risk scored", detail: "High · 78" },
          { label: "Retention offer sent", detail: "10 bps off for 6 months" },
          { label: "Offer accepted", detail: "Volume recovering" },
        ]} />
      <SequenceCard id="T6200cr" kicker="SUPPORT" title="Operations Support & AI Ticketing" Icon={Bot}
        runLabel="Handle ticket" outcome="Resolved by AI · 41 seconds"
        steps={[
          { label: "Ticket received", detail: "\"Terminal won't connect\"" },
          { label: "AI diagnosis", detail: "Wi-Fi band mismatch (5GHz)" },
          { label: "Fix steps sent", detail: "Switch to 2.4GHz · reboot" },
          { label: "Merchant confirmed", detail: "Ticket closed" },
        ]} />
    </>
  );
}
